import fetch from 'auth/GenericFetchInterceptor'

const PazientiDocumentaleService = {}


//###############DOCUMENTALE
PazientiDocumentaleService.getDocuments = function (id) {
    return fetch({
        url: `/api/patients/${id}?fields=documentale`,
        method: 'GET'
    })
}
PazientiDocumentaleService.downloadFile = function (objectKey) {
    return fetch({
        url: `/api/downloadfile?objectKey=${objectKey}`,
        method: 'GET',
    })
}
PazientiDocumentaleService.viewFile = function (objectKey) {
    return fetch({
        url: `/api/view-file?objectKey=${objectKey}`,
        method: 'GET',
    })
}
PazientiDocumentaleService.downloadFile = function (objectKey) {
    return fetch({
        url: `/api/downloadfile?objectKey=${objectKey}`,
        method: 'GET',
    })
}

PazientiDocumentaleService.upload = function (data, id) {
    return fetch({
        url: `/api/upload`,
        method: 'post',
        data: data
    })
}

PazientiDocumentaleService.updatePatient = function (id, data) {
    return fetch({
        url: `/api/patients/${id}`,
        method: 'put',
        data: data
    })
}

PazientiDocumentaleService.removeFileFromBucket = function (objectkey) {
    return fetch({
        url: `/api/delete-object?objectKey=${objectkey}`,
        method: 'delete',
    })
}

PazientiDocumentaleService.removeFileMediaUploader = function (objectId) {
    return fetch({
        url: `/api/upload/files/${objectId}`,
        method: 'delete',
    })
}


///////////###############DIRARIO
PazientiDocumentaleService.getDiario = function (id) {
    return fetch({
        url: `/api/patients/${id}?fields=diario`,
        method: 'GET'
    })
}

PazientiDocumentaleService.aggiornaDiario = function (id, data) {
    return fetch({
        url: `/api/patients/${id}`,
        method: 'put',
        data: data
    })
}
export default PazientiDocumentaleService